import barcelonaIMG from "./assets/clubs-logos/barcelona.png";
import mancityIMG from "./assets/clubs-logos/mancity.png";
import realIMG from "./assets/clubs-logos/real.png";
import atmadridIMG from "./assets/clubs-logos/atmadrid.png";
import interIMG from "./assets/clubs-logos/inter.png";
import milanIMG from "./assets/clubs-logos/milan.png";
import juventusIMG from "./assets/clubs-logos/juventus.png";
import arsenalIMG from "./assets/clubs-logos/arsenal.png";
import manutdIMG from "./assets/clubs-logos/manutd.png";
import chelseaIMG from "./assets/clubs-logos/chelsea.png";
import liverpoolIMG from "./assets/clubs-logos/liverpool.png";
import psgIMG from "./assets/clubs-logos/psg.png";
import bayernIMG from "./assets/clubs-logos/bayern.png";
import dortmundIMG from "./assets/clubs-logos/dortmund.png";
import bayerIMG from "./assets/clubs-logos/bayer.png";

export const dataStatic = {
  barcelona: {
    logo: barcelonaIMG,
    clubName: "Barcelona",
    teamValue: "€940m",
    averageAge: 23.9,
  },
  real: {
    logo: realIMG,
    clubName: "Real Madrid",
    teamValue: "€1.35bn",
    averageAge: "26",
  },
  atmadrid: {
    logo: atmadridIMG,
    clubName: "Atletico M.",
    teamValue: "€569m",
    averageAge: "26.2",
  },
  // italy
  inter: {
    logo: interIMG,
    clubName: "Inter",
    teamValue: "€681m",
    averageAge: "27.8",
  },
  milan: {
    logo: milanIMG,
    clubName: "AC Milan",
    teamValue: "€598m",
    averageAge: "25",
  },
  juventus: {
    logo: juventusIMG,
    clubName: "Juventus",
    teamValue: "€526m",
    averageAge: "26",
  },
  //england
  arsenal: {
    logo: arsenalIMG,
    clubName: "Arsenal",
    teamValue: "€1.17bn",
    averageAge: "25.6",
  },
  manutd: {
    logo: manutdIMG,
    clubName: "Man United",
    teamValue: "€893m",
    averageAge: "25.1",
  },
  chelsea: {
    logo: chelseaIMG,
    clubName: "Chelsea",
    teamValue: "€1.14bn",
    averageAge: "23",
  },

  mancity: {
    logo: mancityIMG,
    clubName: "Man City",
    teamValue: "€1.29bn",
    averageAge: "26.6",
  },
  liverpool: {
    logo: liverpoolIMG,
    clubName: "Liverpool",
    teamValue: "€926m",
    averageAge: "25.2",
  },
  //france
  psg: {
    logo: psgIMG,
    clubName: "PSG",
    teamValue: "€957m",
    averageAge: "23.6",
  },
  //germany
  bayern: {
    logo: bayernIMG,
    clubName: "Bayern Munich",
    teamValue: "€947m",
    averageAge: "25.4",
  },
  dortmund: {
    logo: dortmundIMG,
    clubName: "Borussia Dortmund",
    teamValue: "€511m",
    averageAge: "24.3",
  },
  bayer: {
    logo: bayerIMG,
    clubName: "Bayer 04",
    teamValue: "€667m",
    averageAge: "24.9",
  },
};
